<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-select
          v-model="departmentId"
          placeholder="请选择部门"
          style="width: 250px"
          size="mini"
          filterable
          clearable
          @clear="initRep"
        >
          <el-option
            v-for="item in departments"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <span style="margin-right: 10px"></span>
        <!-- 月份区间：只选到月份。
             原因：后端是先按日期过滤、再按 DATE_FORMAT(rq,'%Y-%m') 分组，
             选"1月15日~2月10日"会得到"1月只有半个月、2月只有10天"的半截月份，容易误读。
             改为月份后前端把区间展开成"首月1号 ~ 末月最后一天"再传（接口参数格式不变）。 -->
        <el-date-picker
          v-model="rqScope"
          size="mini"
          type="monthrange"
          value-format="yyyy-MM"
          unlink-panels
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          clearable
          @clear="initRep"
        >
        </el-date-picker>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="initRep"
          style="margin-left: 10px"
          size="mini"
        >
          搜索
        </el-button>
        <!-- 因为表格做了纵向合并，直接使用initRep更新数据后会错位，所以采用路由的方式传查询条件 路由到自己  -->
        <!-- <el-button type="primary" icon="el-icon-search" @click="DepaReportView" style="margin-left: 10px;" size="mini">
					搜索
				</el-button> -->
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button
          type="success"
          @click="downloadExcel"
          style="margin-left: 10px"
          size="mini"
        >
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出数据</el-button
        >

        <!-- <el-button type="success" icon="el-icon-refresh" @click="initRep" size="mini">刷新</el-button> -->
      </div>
    </div>

    <div style="margin-top: 20px">
      <el-table
        v-loading="loading"
        :data="reportData"
        @row-click="openMonthDetail"
        border
        stripe
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :row-style="{ height: '45px', cursor: 'pointer' }"
        height="calc(100vh - 200px)"
        size="mini"
        id="mytable"
        ref="mytable"
        :header-cell-style="{
          background: '#eef1f6',
          color: '#606266',
          borderColor: 'white',
        }"
        style="width: 100%; font-size: 14px"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          fixed
          width="70"
        >
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="部门名称"
          align="center"
          width="130"
          fixed
        >
        </el-table-column>
        <el-table-column
          prop="rqMonth"
          label="月份"
          align="center"
          width="100"
          fixed
        >
        </el-table-column>

        <el-table-column label="收款(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.income) }}</span>
          </template>
        </el-table-column>

        <!--  <el-table-column label="工资" align="center" prop="f1" width="100"></el-table-column> -->
        <el-table-column label="工资(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f1) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="办公费" align="center" prop="f2" width="100"></el-table-column> -->
        <el-table-column label="办公费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f2) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="公关招待费" align="center" prop="f3" width="100"></el-table-column> -->
        <el-table-column label="公关招待费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f3) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="房租费" align="center" prop="f4" width="100"></el-table-column> -->
        <el-table-column label="房租费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f4) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="修理费" align="center" prop="f5" width="100"></el-table-column> -->
        <el-table-column label="修理费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f5) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="水电物业费" align="center" prop="f6" width="100"></el-table-column> -->
        <el-table-column label="水电物业费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f6) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="差旅费" align="center" prop="f7" width="100"></el-table-column> -->
        <el-table-column label="差旅费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f7) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="交通费" align="center" prop="f8" width="100"></el-table-column> -->
        <el-table-column label="交通费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f8) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="固定资产" align="center" prop="f9" width="100"></el-table-column> -->
        <el-table-column label="固定资产(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f9) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="无形资产" align="center" prop="f10" width="100"></el-table-column> -->
        <el-table-column label="无形资产(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f10) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="装修费" align="center" prop="f11" width="100"></el-table-column> -->
        <el-table-column label="装修费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f11) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="通讯费" align="center" prop="f12" width="100"></el-table-column> -->
        <el-table-column label="通讯费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f12) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="五险一金" align="center" prop="f13" width="100"></el-table-column> -->
        <el-table-column label="五险一金(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f13) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="车辆使用费" align="center" prop="f14" width="100"></el-table-column> -->
        <el-table-column label="车辆使用费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f14) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="咨询费" align="center" prop="f15" width="100"></el-table-column> -->
        <el-table-column label="咨询费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f15) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="三项经费" align="center" prop="f16" width="100"></el-table-column> -->
        <el-table-column label="三项经费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f16) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="奖金" align="center" prop="f17" width="100"></el-table-column> -->
        <el-table-column label="奖金(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f17) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="运输费" align="center" prop="f18" width="100"></el-table-column> -->
        <el-table-column label="运输费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f18) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="广告宣传费" align="center" prop="f19" width="100"></el-table-column> -->
        <el-table-column label="广告宣传费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f19) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="税金" align="center" prop="f20" width="100"></el-table-column> -->
        <el-table-column label="税金(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f20) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="其他费用" align="center" prop="f21" width="100"></el-table-column> -->
        <el-table-column label="其他费用(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f21) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 每日明细弹窗：点击某个「月份」行打开；数据来自 /depa/report_detail（部门 + 日期，旧接口原样复用） -->
    <el-dialog
      :title="detailTitle"
      :visible.sync="detailVisible"
      width="80%"
      top="0px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      @close="closeMonthDetail"
    >
      <el-table
        v-loading="detailLoading"
        :data="detailTableData"
        :row-class-name="detailRowClass"
        stripe
        border
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :row-style="{ height: '45px' }"
        height="60vh"
        size="mini"
        :header-cell-style="{
          background: '#eef1f6',
          color: '#606266',
          borderColor: 'white',
        }"
        style="width: 100%; font-size: 14px"
      >
        <el-table-column
          prop="rq"
          label="日期"
          align="center"
          width="110"
          fixed
        >
        </el-table-column>
        <!-- 注意：金额列必须写 prop！cell 虽然用 scoped slot 渲染，但 show-summary 的
             summary-method 是靠 col.property 取字段求和的，没有 prop 会导致合计整行为空 -->
        <el-table-column prop="income" label="收款(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.income) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f1" label="工资(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f1) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f2" label="办公费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f3" label="公关招待费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f3) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f4" label="房租费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f4) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f5" label="修理费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f5) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f6" label="水电物业费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f7" label="差旅费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f7) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f8" label="交通费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f8) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f9" label="固定资产(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f9) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f10" label="无形资产(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f10) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f11" label="装修费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f11) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f12" label="通讯费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f12) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f13" label="五险一金(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f13) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f14" label="车辆使用费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f14) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f15" label="咨询费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f15) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f16" label="三项经费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f16) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f17" label="奖金(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f17) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f18" label="运输费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f18) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f19" label="广告宣传费(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f19) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f20" label="税金(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f20) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="f21" label="其他费用(元)" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.f21) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="success" size="mini" @click="exportMonthDetail">
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出本月明细</el-button
        >
        <el-button size="mini" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";

export default {
  name: "DepaReport",
  data() {
    return {
      reportData: [], // 存放查询结果
      departmentId: null,
      rqScope: [], // 月份区间：["2026-01","2026-03"]；空数组 = 不限（拼参见 buildRqScope）
      loading: false,
      departments: [], //部门id-部门名称下拉框
      // 每日明细弹窗（点击某个月份行打开）
      detailVisible: false,
      detailLoading: false,
      detailTitle: "",
      detailFileBase: "", // 明细导出的文件名前缀，如 "业务发展部_2026-01"
      detailData: [],
    };
  },
  computed: {
    // 表格数据 = 明细行 + 末尾一行「合计」
    // 为什么不用 el-table 自带的 show-summary（表尾层）：
    //   表尾是独立于表体的第三个容器，靠 Element 的 syncPostion 同步横向滚动，
    //   实测出现过"DOM 里有值、屏幕上是空行"（表尾层与表体/滚动条错位）的情况；
    //   放进表体最后一行 + position: sticky 后，横纵滚动都在同一层，天然同步，
    //   且原生横向滚动条位于整张表格最底部（合计行之下），不会和合计行挤在一行。
    // 导出「本月明细」也直接用这个数组，所以 Excel 里同样带合计行。
    detailTableData() {
      const rows = this.detailData || [];
      if (!rows.length) return rows;
      return rows.concat([this.buildTotalRow(rows, "合计", "rq")]);
    },
  },
  mounted() {
    this.initRep();
    this.initDim();
  },
  methods: {
    // getRouterData() {
    // 	if (this.$route.params.departmentId) {
    // 		this.departmentId = this.$route.params.departmentId
    // 	}
    // 	if (this.$route.params.rqScope) {
    // 		this.rqScope = this.$route.params.rqScope
    // 	}
    // },
    // DepaReportView() {
    // 	// vue路由传参  https://www.cnblogs.com/beka/p/8583924.html
    // 	this.$router.push({name: `部门统计报表`, params: {departmentId: this.departmentId,rqScope: this.rqScope}})  // 带参数 传 只能采用 {name: xx ,params" yyy} 模式
    // 	this.initRep()
    // 	// window.location.reload()
    // },
    moneyNumber(val) {
      // return val.toLocaleString("zh-Hans-CN",{style:"currency",currency:"CNY"})
      // return val.toLocaleString()

      if (val == 0) {
        return "";
      } else {
        return val.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    // 「YYYY-MM」-> 该月最后一天（m 是 1-based，new Date(y, m, 0) 即 m 月最后一天）
    monthLastDay(monthStr) {
      const parts = String(monthStr || "").split("-");
      const y = Number(parts[0]);
      const m = Number(parts[1]);
      if (!y || !m) return "";
      return String(new Date(y, m, 0).getDate()).padStart(2, "0");
    },
    // 月份区间 -> 后端参数 "起,止"（起 = 首月 1 号，止 = 末月最后一天）
    buildRqScope() {
      const val = this.rqScope;
      if (!val || !val.length || !val[0]) return "";
      const beginMonth = val[0];
      const endMonth = val.length > 1 && val[1] ? val[1] : val[0];
      const endDay = this.monthLastDay(endMonth);
      if (!endDay) return "";
      return beginMonth + "-01," + endMonth + "-" + endDay;
    },
    initRep() {
      this.loading = true;
      // 需求 6：只取「部门 + 月份」汇总，不再取「部门 + 日期」明细（接口 /depa/report_month）
      let url = "/depa/report_month?";

      if (this.departmentId) {
        url += "departmentId=" + this.departmentId + "&";
      }

      // 月份区间 -> "起,止"：后端 /depa/report_month 只认 rqScope=起,止
      const rqScopeParam = this.buildRqScope();
      if (rqScopeParam) {
        url += "rqScope=" + rqScopeParam; // 前面已带 ? 或 &，这里不要重复加 &
      }
      this.getRequest(url).then((resp) => {
        if (resp) {
          // console.log(resp.result)
          // alert(JSON.stringify(resp.result))
          this.reportData = resp.result;
        }
        this.loading = false;
      });
    },
    initDim() {
      if (!window.sessionStorage.getItem("departments")) {
        this.postRequest("/dim/dim_table_char/department").then((resp) => {
          if (resp) {
            this.departments = resp.result;
            this.saveDictCache("departments", resp.result);
          }
        });
      } else {
        this.departments = this.dictCache("departments");
      }
    },
    // ==================== 导出 Excel（exceljs，数据驱动，不读 DOM） ====================
    // 与需求 1c / 需求 4 同一套方案。本页没有分页，reportData 本身就是"当前筛选条件下的全部记录"，
    // 所以直接导出内存里的数据，不再额外请求接口。
    // 文件名用的日期后缀：YYYYMMDD
    exportFileDate() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`;
    },
    // 导出列定义：与页面表格列一致，去掉"序号"列（序号不是数据）
    getExportColumns() {
      return [
        { header: "部门名称", key: "departmentName", width: 16, align: "left" },
        { header: "月份", key: "rqMonth", width: 10 },
        { header: "收款(元)", key: "income", width: 13, money: true },
        { header: "工资(元)", key: "f1", width: 13, money: true },
        { header: "办公费(元)", key: "f2", width: 13, money: true },
        { header: "公关招待费(元)", key: "f3", width: 15, money: true },
        { header: "房租费(元)", key: "f4", width: 13, money: true },
        { header: "修理费(元)", key: "f5", width: 13, money: true },
        { header: "水电物业费(元)", key: "f6", width: 15, money: true },
        { header: "差旅费(元)", key: "f7", width: 13, money: true },
        { header: "交通费(元)", key: "f8", width: 13, money: true },
        { header: "固定资产(元)", key: "f9", width: 13, money: true },
        { header: "无形资产(元)", key: "f10", width: 13, money: true },
        { header: "装修费(元)", key: "f11", width: 13, money: true },
        { header: "通讯费(元)", key: "f12", width: 13, money: true },
        { header: "五险一金(元)", key: "f13", width: 13, money: true },
        { header: "车辆使用费(元)", key: "f14", width: 15, money: true },
        { header: "咨询费(元)", key: "f15", width: 13, money: true },
        { header: "三项经费(元)", key: "f16", width: 13, money: true },
        { header: "奖金(元)", key: "f17", width: 13, money: true },
        { header: "运输费(元)", key: "f18", width: 13, money: true },
        { header: "广告宣传费(元)", key: "f19", width: 15, money: true },
        { header: "税金(元)", key: "f20", width: 13, money: true },
        { header: "其他费用(元)", key: "f21", width: 13, money: true },
      ];
    },
    // 用数据数组生成 Excel（exceljs 体积较大，动态导入，仅在点击导出时加载）
    // rows      - 要导出的数据数组
    // fileName  - 文件名，如 "部门统计报表_20260212.xlsx"
    // sheetName - 工作表名，默认取文件名去掉扩展名
    // columns 可选：不传时用主表（月度汇总）的列定义
    async exportRowsToExcel(rows, fileName, sheetName, columns) {
      const mod = await import(/* webpackChunkName: "exceljs" */ "exceljs");
      // 兼容 CJS 模块被 webpack 包装成 { default: ... } 的情况
      const ExcelJS =
        mod && mod.Workbook ? mod : mod && mod.default ? mod.default : mod;
      const cols = columns && columns.length ? columns : this.getExportColumns();

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(
        sheetName || String(fileName || "Sheet1").replace(/\.xlsx$/i, "")
      );

      // 列定义（表头行由 cols.header 自动生成）
      sheet.columns = cols.map((col, i) => ({
        header: col.header,
        key: "c" + i,
        width: col.width,
      }));

      const thin = { style: "thin", color: { argb: "FFD0D0D0" } };

      // 表头样式：加粗 + 灰底 + 居中 + 边框
      const headerRow = sheet.getRow(1);
      headerRow.height = 22;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, size: 11, color: { argb: "FF515A6E" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFEEF1F6" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { top: thin, left: thin, bottom: thin, right: thin };
      });

      // 冻结首行：滚动时表头常驻
      sheet.views = [{ state: "frozen", ySplit: 1 }];

      // 数据行
      (rows || []).forEach((row) => {
        const values = cols.map((col) => {
          const raw = col.format ? col.format(row) : row[col.key];
          // 空值写成真正的空单元格，不写 "--"，避免影响 Excel 求和
          if (raw === null || raw === undefined || raw === "") return null;
          if (col.money) {
            const n = Number(raw);
            return isNaN(n) ? null : n;
          }
          return raw;
        });
        const added = sheet.addRow(values);

        cols.forEach((col, i) => {
          const cell = added.getCell(i + 1);
          cell.border = {
            top: { style: "thin", color: { argb: "FFE8E8E8" } },
            left: { style: "thin", color: { argb: "FFE8E8E8" } },
            bottom: { style: "thin", color: { argb: "FFE8E8E8" } },
            right: { style: "thin", color: { argb: "FFE8E8E8" } },
          };
          if (col.money) {
            // 千分位 + 两位小数；保留数值类型，可在 Excel 中继续排序/求和
            cell.numFmt = "#,##0.00";
            cell.alignment = { horizontal: "right", vertical: "middle" };
          } else {
            cell.alignment = {
              horizontal: col.align || "center",
              vertical: "middle",
            };
          }
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        fileName
      );
    },
    // 导出入口：导出当前筛选条件下的全部汇总行 + 末尾一行「总计」
    // （不读 DOM，不动表格，无需还原分页状态）
    downloadExcel() {
      const rows = this.reportData || [];
      if (!rows.length) {
        this.$message({ type: "warning", message: "当前筛选条件下没有数据" });
        return;
      }
      // 最后追加一行「总计」：22 个金额列求和，标签写在「部门名称」列
      const allRows = rows.concat([this.buildTotalRow(rows, "总计", "departmentName")]);
      const fileName = "部门统计报表_" + this.exportFileDate() + ".xlsx";
      return this.exportRowsToExcel(allRows, fileName, "部门统计报表").catch(
        (e) => {
          console.log(e);
          this.$message({ type: "error", message: "导出失败，请重试" });
        }
      );
    },
    // ==================== 点击月份行 → 每日明细弹窗 ====================
    // 明细复用旧的 /depa/report_detail（部门 + 日期），后端 0 改动
    openMonthDetail(row) {
      if (!row || !row.departmentId || !row.rqMonth) return;
      // 该月首末日（复用 monthLastDay，避免两处重复同一算法）
      const begin = row.rqMonth + "-01";
      const end = row.rqMonth + "-" + this.monthLastDay(row.rqMonth);
      const deptLabel = row.departmentName || "部门" + row.departmentId;

      this.detailTitle = deptLabel + " - " + row.rqMonth + " 每日明细";
      this.detailFileBase = deptLabel + "_" + row.rqMonth + "_每日明细";
      this.detailData = [];
      this.detailLoading = true;
      this.detailVisible = true;

      const url =
        "/depa/report_detail?departmentId=" +
        row.departmentId +
        "&rqScope=" +
        begin +
        "," +
        end;
      this.getRequest(url)
        .then((resp) => {
          const list = (resp && resp.result) || [];
          // 过滤接口返回的「部门小计」行：departmentId='999'、日期是哨兵值 2999-01-01。
          // 不能用「名字含小计」判断：部门名称为空时，那条小计的 departmentName 也是 null。
          this.detailData = list.filter(
            (it) => String(it.departmentId) !== "999"
          );
          this.detailLoading = false;
        })
        .catch((e) => {
          this.detailLoading = false;
          console.log(e);
          this.$message({ type: "error", message: "明细加载失败，请重试" });
        });
    },
    closeMonthDetail() {
      this.detailVisible = false;
      this.detailData = [];
      this.detailTitle = "";
      this.detailFileBase = "";
    },
    // 合计行（表体最后一行）加样式类：钉在底部 + 灰底加粗
    detailRowClass({ row }) {
      return row && row.__isTotal ? "depa-detail-total" : "";
    },
    // 生成「合计 / 总计」行：只对 22 个金额列求和，标签写在 labelKey 指定的那一列上
    // （key 列表与 getExportColumns / getDetailExportColumns 的金额列保持一致）
    buildTotalRow(rows, label, labelKey) {
      const keys = [
        "income",
        "f1",
        "f2",
        "f3",
        "f4",
        "f5",
        "f6",
        "f7",
        "f8",
        "f9",
        "f10",
        "f11",
        "f12",
        "f13",
        "f14",
        "f15",
        "f16",
        "f17",
        "f18",
        "f19",
        "f20",
        "f21",
      ];
      const row = { __isTotal: true };
      row[labelKey] = label;
      keys.forEach((k) => {
        row[k] = (rows || []).reduce((sum, r) => sum + Number(r[k] || 0), 0);
      });
      return row;
    },
    // 明细导出列：日期 + 22 个金额列（与弹窗表格一致）
    getDetailExportColumns() {
      return [
        { header: "日期", key: "rq", width: 12 },
        { header: "收款(元)", key: "income", width: 13, money: true },
        { header: "工资(元)", key: "f1", width: 13, money: true },
        { header: "办公费(元)", key: "f2", width: 13, money: true },
        { header: "公关招待费(元)", key: "f3", width: 15, money: true },
        { header: "房租费(元)", key: "f4", width: 13, money: true },
        { header: "修理费(元)", key: "f5", width: 13, money: true },
        { header: "水电物业费(元)", key: "f6", width: 15, money: true },
        { header: "差旅费(元)", key: "f7", width: 13, money: true },
        { header: "交通费(元)", key: "f8", width: 13, money: true },
        { header: "固定资产(元)", key: "f9", width: 13, money: true },
        { header: "无形资产(元)", key: "f10", width: 13, money: true },
        { header: "装修费(元)", key: "f11", width: 13, money: true },
        { header: "通讯费(元)", key: "f12", width: 13, money: true },
        { header: "五险一金(元)", key: "f13", width: 13, money: true },
        { header: "车辆使用费(元)", key: "f14", width: 15, money: true },
        { header: "咨询费(元)", key: "f15", width: 13, money: true },
        { header: "三项经费(元)", key: "f16", width: 13, money: true },
        { header: "奖金(元)", key: "f17", width: 13, money: true },
        { header: "运输费(元)", key: "f18", width: 13, money: true },
        { header: "广告宣传费(元)", key: "f19", width: 15, money: true },
        { header: "税金(元)", key: "f20", width: 13, money: true },
        { header: "其他费用(元)", key: "f21", width: 13, money: true },
      ];
    },
    // 导出当前弹窗里的本月明细（数据已在内存，不再请求接口）
    // 用 detailTableData：末尾自带一行「合计」，与弹窗里看到的一致
    exportMonthDetail() {
      const rows = this.detailTableData || [];
      if (!rows.length) {
        this.$message({ type: "warning", message: "没有可导出的明细数据" });
        return;
      }
      const base = String(this.detailFileBase || "部门明细").replace(
        /[\\/:*?"<>|]/g,
        "_"
      );
      const fileName = base + "_" + this.exportFileDate() + ".xlsx";
      return this.exportRowsToExcel(
        rows,
        fileName,
        "每日明细",
        this.getDetailExportColumns()
      ).catch((e) => {
        console.log(e);
        this.$message({ type: "error", message: "导出失败，请重试" });
      });
    },
  },
};
</script>

<style>
/* 明细弹窗的合计行：钉在表体底部（纵向滚动时始终可见），
   横向滚动与数据行处于同一层、天然同步；
   原生横向滚动条位于整张表格最下方（合计行之下），不会与合计行同行。

   两个踩过的坑（别再改回去）：
   1) position:sticky 必须加在【行 tr】上：只写在 td 上时 Chrome 完全不让它移动
      （实测 top:0 / bottom:0 都不动；加上 tr 的 sticky 后才钉住）；
   2) 选择器要能压过 Element 的 `.el-table .el-table__cell{position:relative;...}`（特异性 0,2,0），
      否则 td 的 position 会被覆盖成 relative。 */
.el-table .depa-detail-total {
  position: sticky;
  bottom: 0;
  z-index: 3;
}
.el-table .depa-detail-total > td.el-table__cell {
  position: static;
  z-index: 3;
  background-color: #f5f7fa !important;
  font-weight: 600;
}
</style>
